import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FTSCustomProcedureField = _resolveComponent("FTSCustomProcedureField")!
  const _component_TreeMultiselect = _resolveComponent("TreeMultiselect")!
  const _component_InputBlock = _resolveComponent("InputBlock")!
  const _component_FTSFilterWrapperRow = _resolveComponent("FTSFilterWrapperRow")!
  const _component_ComponentInput = _resolveComponent("ComponentInput")!
  const _component_FTSFilterWrapperGroup = _resolveComponent("FTSFilterWrapperGroup")!
  const _component_UserCustomsHouseListsModal = _resolveComponent("UserCustomsHouseListsModal")!
  const _component_UserTransportListsModal = _resolveComponent("UserTransportListsModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_FTSFilterWrapperGroup, _mergeProps(_ctx.$attrs, { title: "Условия перемещения товара" }), {
      default: _withCtx(() => [
        _createVNode(_component_FTSFilterWrapperRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_FTSCustomProcedureField, {
              modelValue: _ctx.localFilter.customsProcedureIds,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localFilter.customsProcedureIds) = $event)),
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_InputBlock, { title: "Условия поставки" }, {
              default: _withCtx(() => [
                _createVNode(_component_TreeMultiselect, {
                  modelValue: _ctx.localFilter.deliveryTermsIds,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localFilter.deliveryTermsIds) = $event)),
                  options: _ctx.getDeliveryTerms,
                  disabled: _ctx.disabled,
                  valueProp: "id",
                  labelProp: "name",
                  menuMode: _ctx.menuModes.COMBINED_MODAL
                }, null, 8, ["modelValue", "options", "disabled", "menuMode"])
              ]),
              _: 1
            }),
            _createVNode(_component_InputBlock, {
              title: "Вид транспорта на границе",
              isButtonVisible: "",
              onButtonClick: _ctx.handleOpenTransportModal
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TreeMultiselect, {
                  modelValue: _ctx.localFilter.transportTypesOnBorderIds,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localFilter.transportTypesOnBorderIds) = $event)),
                  options: _ctx.getTransportTypes,
                  disabled: _ctx.disabled,
                  menuMode: _ctx.menuModes.COMBINED_MODAL
                }, null, 8, ["modelValue", "options", "disabled", "menuMode"])
              ]),
              _: 1
            }, 8, ["onButtonClick"]),
            _createVNode(_component_InputBlock, { title: "Вид транспорта внутри страны" }, {
              default: _withCtx(() => [
                _createVNode(_component_TreeMultiselect, {
                  modelValue: _ctx.localFilter.transportTypesInsideCountryIds,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localFilter.transportTypesInsideCountryIds) = $event)),
                  options: _ctx.getTransportTypes,
                  disabled: _ctx.disabled,
                  menuMode: _ctx.menuModes.COMBINED_MODAL
                }, null, 8, ["modelValue", "options", "disabled", "menuMode"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_FTSFilterWrapperRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_InputBlock, {
              title: "Таможенный орган на границе",
              isButtonVisible: "",
              onButtonClick: _ctx.handleOpenCustomsModal
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TreeMultiselect, {
                  modelValue: _ctx.localFilter.customsOrgansOnBorderIds,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localFilter.customsOrgansOnBorderIds) = $event)),
                  valueProp: "id",
                  labelProp: "name",
                  options: _ctx.getCustomsOrgansOnBorderTree,
                  disabled: _ctx.disabled,
                  menuMode: _ctx.menuModes.COMBINED_MODAL
                }, null, 8, ["modelValue", "options", "disabled", "menuMode"])
              ]),
              _: 1
            }, 8, ["onButtonClick"]),
            _createVNode(_component_InputBlock, { title: "Регион" }, {
              default: _withCtx(() => [
                _createVNode(_component_TreeMultiselect, {
                  modelValue: _ctx.localFilter.regionIds,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localFilter.regionIds) = $event)),
                  options: _ctx.getRegionsRfTree,
                  levelEventsLabels: _ctx.getRegionsRfLevelEventsLabels,
                  disabled: _ctx.disabled,
                  menuMode: _ctx.menuModes.COMBINED_MODAL
                }, null, 8, ["modelValue", "options", "levelEventsLabels", "disabled", "menuMode"])
              ]),
              _: 1
            }),
            _createVNode(_component_InputBlock, { title: "Пункт поставки товара" }, {
              default: _withCtx(() => [
                _createVNode(_component_TreeMultiselect, {
                  modelValue: _ctx.localFilter.deliveryGoodsPointIds,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localFilter.deliveryGoodsPointIds) = $event)),
                  options: _ctx.getDeliveryGoodsPoints,
                  disabled: _ctx.disabled,
                  valueProp: "id",
                  labelProp: "name",
                  menuMode: _ctx.menuModes.COMBINED_MODAL
                }, null, 8, ["modelValue", "options", "disabled", "menuMode"])
              ]),
              _: 1
            }),
            _createVNode(_component_InputBlock, { title: "Экспортер (ИНН и наименование)" }, {
              default: _withCtx(() => [
                _createVNode(_component_TreeMultiselect, {
                  modelValue: _ctx.localFilter.exporterIds,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.localFilter.exporterIds) = $event)),
                  options: _ctx.getExporters,
                  disabled: _ctx.disabled,
                  valueProp: "id",
                  labelProp: "name",
                  getLabel: (item) => _ctx.getExporterLabel(item as TFTSExporter),
                  menuMode: _ctx.menuModes.COMBINED_MODAL
                }, null, 8, ["modelValue", "options", "disabled", "getLabel", "menuMode"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_FTSFilterWrapperRow, null, {
          default: _withCtx(() => [
            _createVNode(_component_ComponentInput, {
              modelValue: _ctx.localFilter.isProducer,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.localFilter.isProducer) = $event)),
              id: "producer-field",
              type: "checkbox",
              label: "Производитель",
              mod: "checkbox-green",
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_ComponentInput, {
              modelValue: _ctx.localFilter.isContainer,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.localFilter.isContainer) = $event)),
              id: "container-field",
              type: "checkbox",
              label: "Контейнер",
              mod: "checkbox-green",
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_ComponentInput, {
              modelValue: _ctx.localFilter.isCurrency,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.localFilter.isCurrency) = $event)),
              id: "currency-field",
              type: "checkbox",
              label: "Валюта",
              mod: "checkbox-green",
              disabled: _ctx.disabled
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16),
    _createVNode(_component_UserCustomsHouseListsModal, {
      showModal: _ctx.isCustomsModalOpen,
      onClose: _ctx.handleCloseCustomsModal,
      onDeletedSubtreeIds: _ctx.handleDeletedCustomsSubtree
    }, null, 8, ["showModal", "onClose", "onDeletedSubtreeIds"]),
    _createVNode(_component_UserTransportListsModal, {
      showModal: _ctx.isTransportModalOpen,
      onClose: _ctx.handleCloseTransportModal,
      onDeletedSubtreeIds: _ctx.handleDeletedTransportSubtree
    }, null, 8, ["showModal", "onClose", "onDeletedSubtreeIds"])
  ], 64))
}